import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateContent } from '../services/requests';
import type { UpdateContentRequest } from '../schemas/auth';
import useNotification from '../components/Notification';

interface UseUpdateContentOptions {
  onSuccess?: () => void;
}

export const useUpdateContent = (options?: UseUpdateContentOptions) => {
  const { showNotification } = useNotification();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateContentRequest }) => updateContent(id, payload),
    onSuccess: (data) => {
      showNotification({
        type: 'success',
        message: 'Content Updated',
        description: 'The content has been updated successfully.',
      });
      queryClient.invalidateQueries({
        queryKey: ['listContents'],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: ['infiniteContents'],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: ['contentDetail'],
        exact: false,
      });

      if (options?.onSuccess) {
        options.onSuccess();
      }
    },
  });
};
